import styled from "styled-components";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 2px 14px 4px 14px;
  /* background: rgba(0, 0, 0, 0.07);
  backdrop-filter: blur(5px); */
`;

export const StyledMetricsGrid = styled.div`
  display: flex;
  flex-direction: row;
  /* display: grid;
  grid-template-columns: repeat(${(props) => props.columns || 1}, 1fr); */
  gap: 8px;
  align-items: center;
  justify-content: center;
`;

export const StyledMetricsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* background: rgba(255, 255, 255, 0.4); */
  /* background: rgba(0, 0, 0, 0.07);
  backdrop-filter: blur(5px); */
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 6px 8px;
  border-radius: 8px;
  gap: 4px;
  text-align: center;
  height: 100%;
  box-sizing: border-box;
  min-width: 157px;

  /* span:first-child {
    font-size: 18px;
  } */

  span:last-child {
    font-size: 12px;
    color: var(--fontColor);
  }
`;

export const StyledMetricsTagContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2px;
  justify-content: center;
  align-items: center;
`;

export const StyledMetricsTag = styled.div`
  margin: 0.125rem;
  border-radius: 0.9375rem;
  white-space: nowrap;
  font-size: 10px;
  padding: 0 6px;
  height: 20px;
  min-width: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  text-align: center;
  text-transform: lowercase;
  background: ${(props) => props.background || "var(--elementBackground)"};
  color: ${(props) => props.color || "#fff"};
`;
